import Image from 'next/image';
import Link from 'next/link';
import { useMedia } from 'react-use';

import { buttons } from '../../../styles/buttons';
import { breakpoints } from '../../../styles/util';
import { routes } from '../../../utils/routes';
import { StyledH2, StyledParagraph, StyledPrimaryCell } from '../../SwapTokens/utils';

export function DeepLiquiditySection() {
  const isMobile = useMedia(breakpoints.mobile, false);

  return (
    <StyledPrimaryCell className="flex flex-col items-center justify-center px-12 pb-[68px] pt-[68px] desktop:flex-row desktop:justify-between desktop:items-start">
      <div className="max-w-[474px]">
        <StyledH2>
          Deep liquidity. <br />
          AMM and RFQ combined.
        </StyledH2>
        <StyledParagraph>
          Matcha combines liquidity from 130+ exchanges, intelligently splitting trades across AMM
          and RFQ for the best prices.
        </StyledParagraph>
        <Link href={{ pathname: routes.LIQUIDITY_SOURCES }}>
          <div
            className={buttons({
              size: 'medium',
              color: 'black',
              class: 'ml-0 mr-auto mt-10 mb-12',
              shape: 'pill',
            })}
          >
            See all liquidity sources
          </div>
        </Link>
      </div>
      <Image
        className="max-w-full h-auto mt-4 desktop:mt-0"
        width={isMobile ? 407 : 570}
        height={isMobile ? 228 : 319}
        alt=""
        src="/images/swap-tokens/deep-liquidity.png"
      />
    </StyledPrimaryCell>
  );
}
